import styled from "styled-components";
import { colors } from "../../util/constants";

const NewButton = styled.button`
  font-size: ${props => props.size};
  color: ${props => (props.secondary ? colors.black : props.color)};
  margin: ${props => props.margin};
  font-weight: ${props => props.weight};
  cursor: pointer;
  background-color: ${props => (props.secondary ? "#FFFFFF" : props.bg)};
  height: 2.875rem;
  border-radius: 3px;
  border: ${props => props.border};
  display: ${props => (props.block ? "block" : "initial")};
  width: ${props => (props.block ? "100%" : "initial")};
  padding: 0 1rem;

  outline: none;
  &:hover {
    background-color: ${props =>
      props.secondary ? "#F7F7F7" : colors.hoverGreen};
  }
  &:disabled {
    background-color: ${colors.disabledGreen};
    cursor: not-allowed;
  }
`;

NewButton.defaultProps = {
  size: "1rem",
  color: "#ffffff",
  weight: "500",
  margin: "0 0 1rem",
  bg: colors.green,
  border: "none"
};

export default NewButton;



// WEBPACK FOOTER //
// ./src/components/FormComponents/NewButton.jsx